import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import * as React from 'react';
import { DecoratedSlide } from '../common/DecoratedSlide';
import SlideContent from '../common/SlideContent';
export default observer(function InstructionEdit({ onMainCTAClick, }) {
    return (_jsx(DecoratedSlide, { children: _jsx(SlideContent, { ctaOnClick: onMainCTAClick, maxHeadingLength: 512, maxParagraphLength: 512 }) }));
});
